





















import Component from 'vue-class-component';
import CommonPaginatedTable from '@/components/table/CommonPaginatedTable.vue';
import {AuditTrailDialogRequest, PageInfo} from '@/model/CommonModel';
import DialogEventsMixin from '@/components/dialog/DialogEventsMixin';
import {Mixins} from 'vue-property-decorator';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';
import CommonButton from '@/components/button/CommonButton.vue';

@Component({
    mixins: [DialogEventsMixin],
    components: {
        CommonButton,
        CommonPromptDialog,
        CommonPaginatedTable
    }
})
export default class AuditTrailDialog extends Mixins<DialogEventsMixin>(DialogEventsMixin) {
    private readonly DEFAULT_WIDTH: string = '800px';

    private dialogVisible = false;
    private columns: any = [];
    private values: any = [];
    private pageInfo: PageInfo | undefined;
    private width: string = this.DEFAULT_WIDTH;

    get isVisible() {
        return this.dialogVisible;
    }

    set isVisible(param) {
        this.dialogVisible = false;
    }

    get getPageInfo() {
        return this.pageInfo
            ? this.pageInfo
            : {
                menuId: this.$route.meta.menuId,
                pageNo: 1,
                rowCount: this.values.length,
                totalCount: this.values.length,
                totalPage: 1
            };
    }

    public mounted() {
        this.$modal
            .getEventBus()
            .$on('showAuditTrailDialog', (params: AuditTrailDialogRequest) => {
                this.columns = params.columnList;
                this.values = params.auditTrailList;
                this.pageInfo = params.pageInfo;
                this.width = params.width ? params.width : this.DEFAULT_WIDTH;
                this.show();
            });

        this.$modal.getEventBus().$on('hideAuditTrailDialog', () => this.hide());
    }

    public show() {
        this.dialogVisible = true;
    }

    public hide() {
        this.dialogVisible = false;
    }

    public afterClosed() {
        this.values = [];
        this.columns = [];
    }

    public destroyed() {
        this.$modal.getEventBus().$off('showAuditTrailDialog');
        this.$modal.getEventBus().$off('hideAuditTrailDialog');
    }
}
